import { useProcessTableSort } from "context/ProcessTableContext";
import { canSort } from "./utils/ProcessTableColumnsUtils";
import { DropdownSelect } from "@avenueops/web-components";
import { GroupBy, SortOrder } from "@avenueops/shared-types";
import { TextAlignTopIcon, TextAlignBottomIcon } from "@radix-ui/react-icons";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useProcessTableGroupBy } from "../../context/ProcessTableContext/ProcessTableContext";

interface Props {
  columnId: string;
  title: string;
}

export function ProcessTableColumnHeader({ columnId, title }: Props) {
  const [sort, setSort] = useProcessTableSort();
  const [groupBy, setGroupBy] = useProcessTableGroupBy();

  const setColumnSort = (ordering: SortOrder | undefined) => {
    const newSort = sort.filter((s) => s.column !== columnId);
    if (ordering) {
      newSort.push({ column: columnId, order: ordering });
    }
    setSort(newSort);
  };

  const columnSort = sort.find((s) => s.column === columnId)?.order;
  return (
    <div className="flex flex-row w-full gap-3 items-center">
      <div className="flex flex-1">{title}</div>
      {canSort(columnId) ? (
        <div>
          <DropdownSelect
            disabled={sortMatchesGroupBy(columnId, groupBy)}
            name={`${columnId}_sort`}
            type="ICON"
            size="MEDIUM"
            IndicatorIcon={ChevronDownIcon}
            options={[
              { label: "Sort Ascending", value: SortOrder.ASC, icon: <TextAlignTopIcon className="h-5 w-5 pt-1 shrink-0" /> },
              { label: "Sort Descending", value: SortOrder.DESC, icon: <TextAlignBottomIcon className="h-5 w-5 pb-1 shrink-0" /> },
            ]}
            onChange={(val: string | undefined) => {
              setColumnSort(val as SortOrder);
            }}
            selectedValue={columnSort}
            hideSearchBar
          />
        </div>
      ) : null}
    </div>
  );
}

function sortMatchesGroupBy(columnId: string, groupBy: GroupBy | undefined): boolean {
  if (!groupBy) {
    return false;
  }

  switch (groupBy) {
    case GroupBy.PRIORITY:
      return columnId === "META_priority";
    case GroupBy.ASSIGNEE:
      return columnId === "META_assigneeLabel";
    case GroupBy.STATUS:
      return columnId === "META_statusLabel";
    case GroupBy.ESCALATION_GROUP:
      return false;
    case GroupBy.WORKFLOW:
      return columnId === "META_workflowTitle";
  }
}
